import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';
import Lang from 'lang.js';
import { isEmpty } from 'ramda';
import numeral from 'numeral';

import translations from './settings/Translations';
import Api from './settings/Api';

import App from './App';

const lang = new Lang();
const locale = document.documentElement.lang;

lang.setFallback('es');
lang.setLocale(locale);
lang.setMessages(translations);

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.use(Api);

Vue.filter('trans', (...args) => lang.get(...args));
Vue.filter('empty', (value, negate = false) => {
    let result = isEmpty(value);
    if (negate) {
        result = !isEmpty(value);
    }
    return result;
});

numeral.register('locale', 'es', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    }
});

Vue.filter('num_format', (number, format = '0.0[,]00', locale = 'es') => {
    const num = Number(number);
    numeral.locale(locale);
    return numeral(num).format(format);
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    components: { App },
    template: '<app/>'
});



// WEBPACK FOOTER //
// ./src/main.js